import { render, staticRenderFns } from "./getWord.vue?vue&type=template&id=751170de&scoped=true&"
import script from "./getWord.vue?vue&type=script&lang=js&"
export * from "./getWord.vue?vue&type=script&lang=js&"
import style0 from "./getWord.vue?vue&type=style&index=0&id=751170de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751170de",
  null
  
)

export default component.exports